var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "collapse-container" },
    [
      _c(
        "div",
        {
          staticClass: "fit-content d-flex",
          class: { pointer: !_vm.disabled },
          attrs: {
            "aria-controls": _vm.key,
            "aria-expanded": _vm.model ? "true" : "false"
          },
          on: { click: _vm.toggle }
        },
        [
          _c(
            "div",
            { staticClass: "collapse-icon rounded-circle text-white" },
            [
              _c("i", {
                staticClass: "far",
                class: {
                  "fa-chevron-down": _vm.model,
                  "fa-chevron-right": !_vm.model
                }
              })
            ]
          ),
          _c("div", { staticClass: "ml-2 font-weight-bold" }, [
            _vm._v(" " + _vm._s(_vm.title) + " ")
          ])
        ]
      ),
      _c(
        "b-collapse",
        { staticClass: "my-3", attrs: { id: _vm.key, visible: _vm.model } },
        [_vm._t("default")],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }